import { Link } from 'react-router-dom';

export type SalesProcessStage='develop'|'opportunity'|'quote'|'invoice'|'won';
const stages:{key:SalesProcessStage;label:string;hint:string}[]=[
 {key:'develop',label:'Develop',hint:'Lead development'},
 {key:'opportunity',label:'Opportunity',hint:'Project, products & forecast'},
 {key:'quote',label:'Quote',hint:'Customer quote'},
 {key:'invoice',label:'Invoice',hint:'Finance / payment'},
 {key:'won',label:'Won',hint:'Paid & released to Operations'},
];

type StageLink={href?:string;onClick?:()=>void;disabled?:boolean};
export function SalesProcessBar({current,links,lost=false}:{current:SalesProcessStage;links?:Partial<Record<SalesProcessStage,StageLink>>;lost?:boolean}){
 const activeIndex=stages.findIndex(s=>s.key===current);
 return <div className="sales-process-wrap">
  <div className="sales-process-heading"><strong>Sales process</strong>{lost&&<span className="status-pill status-lost">Lost</span>}</div>
  <div className="sales-process-bar" role="navigation" aria-label="Sales process stages">
   {stages.map((stage,index)=>{
    const state=index<activeIndex?'complete':index===activeIndex?'current':'future';
    const action=links?.[stage.key];
    const inner=<><span className="sales-process-marker">{index<activeIndex?'✓':index+1}</span><span className="sales-process-copy"><strong>{stage.label}</strong><small>{stage.hint}</small></span></>;
    if(action?.href&&!action.disabled)return <Link key={stage.key} className={`sales-process-stage ${state} actionable`} to={action.href}>{inner}</Link>;
    if(action?.onClick&&!action.disabled)return <button key={stage.key} type="button" className={`sales-process-stage ${state} actionable`} onClick={action.onClick}>{inner}</button>;
    return <div key={stage.key} className={`sales-process-stage ${state}${action?.disabled?' disabled':''}`}>{inner}</div>;
   })}
  </div>
 </div>
}

export function opportunityProcessStage(stageKey:string|undefined,status?:string):SalesProcessStage{
 if(status==='won'||stageKey==='won')return'won';
 if(stageKey==='invoice')return'invoice';
 if(stageKey==='quote')return'quote';
 return'opportunity';
}
